var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 1,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 4.5,
    stroke: "#112347"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 11.5C8.5 10.3954 9.39543 9.5 10.5 9.5H21.5C22.6046 9.5 23.5 10.3954 23.5 11.5V18.125C23.5 19.2296 22.6046 20.125 21.5 20.125H10.5C9.39543 20.125 8.5 19.2296 8.5 18.125V11.5Z",
    stroke: "#6C2AD2",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.92131 10.8029C9.41709 10.3407 9.74409 9.5 10.4281 9.5H21.5719C22.2559 9.5 22.5829 10.3407 22.0787 10.8029L18.0272 14.5168C16.8802 15.5681 15.1198 15.5681 13.9728 14.5168L9.92131 10.8029Z",
    stroke: "#6C2AD2",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.5606a42b24f8ff29840c43b5cc00d394.svg";
export { ForwardRef as ReactComponent };